import React, { FC, Fragment, MouseEvent } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Divider, Grid, Link, Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';

import { useProtectedClient } from 'hooks';

const useStyles = makeStyles(theme => ({
  divider: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  padded: {
    padding: theme.spacing(2),
  },
  text: {
    fontWeight: theme.typography.fontWeightRegular,
    marginBottom: theme.spacing(4),
  },
}));

const Information: FC = () => {
  const { t } = useTranslation();
  const client = useProtectedClient();
  const classes = useStyles();

  function handleChat(event: MouseEvent) {
    event.preventDefault();
    window.Intercom?.('showNewMessage');
  }

  function renderTopRow() {
    return (
      <Grid container item spacing={3}>
        <Grid item xs={12} sm={6}>
          <Paper className={classes.padded}>
            <Typography color="textSecondary">{t('admin:accountName')}</Typography>
            <Typography variant="subtitle2">{client.title}</Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Paper className={classes.padded}>
            <Typography color="textSecondary">{t('admin:accountCreated')}</Typography>
            <Typography variant="subtitle2">
              {moment.unix(client.created_at).format('ll')}
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    );
  }

  function renderMiddleRow() {
    return (
      <Grid container item>
        <Grid item xs>
          <Paper className={classes.padded}>
            <Typography color="textSecondary">{t('admin:accountDomain')}</Typography>
            <Typography variant="subtitle2">{client.subdomain}</Typography>
          </Paper>
        </Grid>
      </Grid>
    );
  }

  function renderBottomRow() {
    return (
      <Grid container item>
        <Grid item xs>
          <Paper>
            <Grid container direction="column">
              <Grid container item spacing={3}>
                <Grid item xs={12} sm={6}>
                  <div className={classes.padded}>
                    <Typography color="textSecondary">{t('admin:accountEmailDomain')}</Typography>
                    <Typography variant="subtitle2">{client.email_domains[0]}</Typography>
                  </div>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <div className={classes.padded}>
                    <Typography color="textSecondary">
                      {t('admin:accountEmailFromAddress')}
                    </Typography>
                    <Typography variant="subtitle2">
                      {client.email_from_address || t('admin:accountNone')}
                    </Typography>
                  </div>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <div className={classes.padded}>
                  <Typography color="textSecondary">{t('admin:accountEmail')}</Typography>
                  <Typography variant="subtitle2">
                    {client.email_address || t('admin:accountNone')}
                  </Typography>
                </div>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    );
  }

  return (
    <Fragment>
      <Typography variant="subtitle2">{t('admin:accountInformation')}</Typography>
      <Divider className={classes.divider} />
      <Typography variant="subtitle2" className={classes.text}>
        <Trans i18nKey="admin:accountHelp">
          Ask your{' '}
          <Link style={{ cursor: 'pointer' }} color="primary" onClick={handleChat}>
            Client Success
          </Link>{' '}
          manager about editing this information
        </Trans>
      </Typography>
      <Grid container direction="column" spacing={3}>
        {renderTopRow()}
        {renderMiddleRow()}
        {renderBottomRow()}
      </Grid>
    </Fragment>
  );
};

export default Information;
